import { Directive, Input, ElementRef, OnInit, HostListener, HostBinding } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

import { ConfigurationService } from '@oel/js-configuration';
import { ImageDynamiqueSources } from '../../modeles/image-dynamique-sources.modele';

export enum Breakpoint {
  ViewportXsOnly = 321,
  ViewportSOnly = 427,
  ViewportSmUp = 640,
  ViewportS = 768,
  ViewportMdUp = 992,
  ViewportMOnly = 993,
  ViewportLOnly = 1281
}

export const DISPLAY_NO_IMAGE = 'none';

const OEL_STATIC_SPA_URL = 'oel-static-spa-url';

@Directive({
  selector: '[appDynamicBackgroundImage]',
  standalone: false
})
export class DynamicBackgroundImageDirective implements OnInit {
  constructor(private readonly sanitizer: DomSanitizer, private readonly elementRef: ElementRef) {}

  private get staticSpaUrl() {
    const staticSpaUrl = ConfigurationService.getConfig(OEL_STATIC_SPA_URL);
    return staticSpaUrl ? staticSpaUrl : null;
  }
  @Input('appDynamicBackgroundImage')
  imageSource: ImageDynamiqueSources;

  currentImageSource: String;

  @HostBinding('style.background-image')
  public backgroundImage: SafeStyle;

  ngOnInit() {
    this.setImageBasedOnWindowSize();
  }

  @HostListener('window:resize')
  onResize() {
    this.setImageBasedOnWindowSize();
  }

  private setImageBasedOnWindowSize() {
    const windowWidth = window.innerWidth;

    switch (true) {
      case windowWidth < Breakpoint.ViewportXsOnly && !!this.imageSource.mobile:
        this.setBackgroundImage(this.imageSource.mobile);
        break;

      case windowWidth < Breakpoint.ViewportSOnly && !!this.imageSource.mobile:
        this.setBackgroundImage(this.imageSource.mobile);
        break;

      case windowWidth >= Breakpoint.ViewportMOnly &&
        !!this.imageSource.desktop &&
        this.imageSource.desktop !== DISPLAY_NO_IMAGE:
        this.setBackgroundImage(this.imageSource.desktop);
        break;

      case windowWidth >= Breakpoint.ViewportSOnly &&
        !!this.imageSource.tablette &&
        this.imageSource.mobile !== DISPLAY_NO_IMAGE:
        this.setBackgroundImage(this.imageSource.tablette);
        break;

      case windowWidth < Breakpoint.ViewportS &&
        !!this.imageSource.mobile &&
        this.imageSource.mobile !== DISPLAY_NO_IMAGE:
        this.setBackgroundImage(this.imageSource.mobile);
        break;

      case windowWidth >= Breakpoint.ViewportLOnly &&
        !!this.imageSource.desktopOnly &&
        this.imageSource.desktop === DISPLAY_NO_IMAGE:
        this.setBackgroundImage(this.imageSource.desktopOnly);
        break;

      case windowWidth >= Breakpoint.ViewportMdUp &&
        !!this.imageSource.desktop &&
        this.imageSource.mobile === DISPLAY_NO_IMAGE:
        this.setBackgroundImage(this.imageSource.desktop);
        break;

      case windowWidth < Breakpoint.ViewportSmUp && this.imageSource.mobile === DISPLAY_NO_IMAGE:
        this.setBackgroundImage(this.imageSource.mobile);
        break;

      case windowWidth >= Breakpoint.ViewportSmUp &&
        !!this.imageSource.tablette &&
        this.imageSource.mobile === DISPLAY_NO_IMAGE:
        this.setBackgroundImage(this.imageSource.tablette);
        break;

      default:
        this.setBackgroundImage(this.imageSource.desktop);
        break;
    }
  }

  private setBackgroundImage(imageSource: string): void {
    if (this.currentImageSource === imageSource) {
      return;
    }

    if (imageSource === DISPLAY_NO_IMAGE) {
      this.unsetBackgroundImage();
      return;
    }

    const backgroundStyle = this.getBackgroundSafeUrl(imageSource);
    this.backgroundImage = backgroundStyle;
    this.currentImageSource = imageSource;
  }

  private unsetBackgroundImage() {
    this.backgroundImage = this.sanitizer.bypassSecurityTrustStyle(DISPLAY_NO_IMAGE);
    this.currentImageSource = DISPLAY_NO_IMAGE;
  }

  private getBackgroundSafeUrl(imageSource: string): SafeStyle {
    const url = `url(${this.staticSpaUrl}/assets/images${imageSource})`;
    return this.sanitizer.bypassSecurityTrustStyle(url);
  }
}
